import { SEO } from '../components/SEO';

export const TermsOfService: React.FC = () => {
  return (
    <>
      <SEO
        title="Terms of Service | Your Casinos"
        description="Terms of service for Your Casinos. Read our terms and conditions for using our website."
        canonical="/policies/terms"
      />

      <div className="min-h-screen bg-black py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Terms of Service
          </h1>
          <div className="glass-card p-8 space-y-6 text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Acceptance of Terms</h2>
              <p>
                By accessing and using this website, you accept and agree to be bound by these Terms of Service. 
                If you do not agree, please do not use this website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Use of Website</h2>
              <p>You agree to use this website only for lawful purposes and in a way that does not:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on the rights of others</li>
                <li>Interfere with the website's operation</li>
                <li>Attempt to gain unauthorized access</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Age Requirement</h2>
              <p>
                You must be 18 years or older to use this website. By using this site, you confirm that 
                you are of legal gambling age in the United Kingdom.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Content and Information</h2>
              <p>
                We provide information for educational and comparison purposes only. We do not guarantee 
                the accuracy, completeness, or timeliness of information. Casino offers and terms may 
                change without notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Affiliate Links</h2>
              <p>
                This website contains affiliate links. We may receive compensation when you click through 
                to casino sites. This does not affect our editorial independence or review ratings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Responsible Gambling</h2>
              <p>
                Gambling should be entertainment, not a way to make money. Please gamble responsibly. 
                If you need help, contact organizations like GambleAware, GamCare, or Gambling Therapy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Limitation of Liability</h2>
              <p>
                We are not responsible for any losses or damages resulting from your use of this website 
                or any casino sites linked from this website. You use this information at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Continued use of the website 
                after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Contact Us</h2>
              <p>
                If you have questions about these terms, please contact us through our website.
              </p>
            </section>

            <section>
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

